import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

function UpdatePerformance({ performance_id }) {
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        cogen_id: '',
        season: '',
        bgas_production: '',
        buy_bgas: '',
        other_fuel: '',
        electricity_export: '',
        working_days: '',
        total_ecity_prod: '',
        factory_usage: '',
        cogen_usage: '',
        total_ecity_export: '',
        ecity_export_perhr: ''
    });

    const [errors, setErrors] = useState({});
    const [successMessage, setSuccessMessage] = useState('');

    useEffect(() => {
        if (!performance_id) return;

        axios.get(`https://backend-zkgn.onrender.com/api/performance/performance/${performance_id}`)
            .then(response => {
                setFormData(response.data);
            })
            .catch(error => {
                console.error("Error fetching performance data:", error);
            });
    }, [performance_id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            await axios.put(`https://backend-zkgn.onrender.com/api/performance/${performance_id}`, formData);
            
            setSuccessMessage('Performance data updated successfully!');

            // ⏳ Wait 1 second & navigate back
            setTimeout(() => {
                navigate(-1);  // Go back to previous page
            }, 1000);

        } catch (error) {
            console.error("Update failed:", error);
            setSuccessMessage('Update failed. Please try again.');
        }
    };

    if (!formData || Object.keys(formData).length === 0) {
        return <div className="text-center mt-5">Loading form...</div>;
    }

    return (
        <div className="container my-5">
            <h4 className="mb-4 text-center">Edit Performance Data</h4>

            {successMessage && (
                <div className="alert alert-info text-center" role="alert">
                    {successMessage}
                </div>
            )}

            <form onSubmit={handleSubmit} className="shadow p-4 rounded bg-light">
                <div className="row g-3">
                    {Object.keys(formData).map((key) =>
                        key !== 'performance_id' && (
                            <div className="col-md-6" key={key}>
                                <label className="form-label text-capitalize">
                                    {key.replace(/_/g, ' ')}
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name={key}
                                    value={formData[key] || ""}
                                    onChange={handleChange}
                                />
                            </div>
                        )
                    )}
                </div>

                <div className="text-center mt-4">
                    <button type="submit" className="btn btn-success px-4">
                        Update
                    </button>
                </div>
            </form>
        </div>
    );
}

export default UpdatePerformance;
